// src/utils/ctcScreening.js
// Shared vocabulary for the CTC Screenings pages (list / form / detail), so the
// three screens can't drift apart on labels or badge colours.

// Mirrors CtcScreeningRecord.Status on the backend. CONVERTED_TO_PATIENT is
// set only by POST /ctc-screenings/{id}/convert-to-patient — never offered as
// an editable choice (the backend rejects it on PUT).
export const SCREENING_STATUSES = [
  { value: 'SCREENED',             label: 'Screened',         badge: 'badge-confirmed' },
  { value: 'FOLLOW_UP_NEEDED',     label: 'Follow-up needed', badge: 'badge-pending' },
  { value: 'IN_TREATMENT',         label: 'In treatment',     badge: 'badge-purple' },
  { value: 'CONVERTED_TO_PATIENT', label: 'Converted',        badge: 'badge-active' },
  { value: 'CLOSED',               label: 'Closed',           badge: 'badge-unknown' },
];

export const EDITABLE_STATUSES = SCREENING_STATUSES.filter(s => s.value !== 'CONVERTED_TO_PATIENT');

export function statusMeta(value) {
  return SCREENING_STATUSES.find(s => s.value === value)
    || { value, label: value || 'Screened', badge: 'badge-unknown' };
}

// The seven per-record case-tracking flags, grouped by modality. `short` is
// the compact badge text used in the list table; `phone` is the same flag as
// plain text on the list's phone layout, where flags are joined with " · " (so
// it can't use `short`, which already contains one). `treatment` marks the
// in-treatment flags, listed after the open ones there.
export const CASE_FLAGS = [
  { key: 'openOralCase',          label: 'Open oral case',          short: 'Oral · open',  phone: 'Oral open',          badge: 'badge-moderate', modality: 'Oral' },
  { key: 'treatmentOralCase',     label: 'Oral case in treatment',  short: 'Oral · tx',    phone: 'Oral in treatment',  badge: 'badge-purple',   modality: 'Oral',         treatment: true },
  { key: 'openCbeCase',           label: 'Open CBE case',           short: 'CBE · open',   phone: 'CBE open',           badge: 'badge-moderate', modality: 'Breast (CBE)' },
  { key: 'treatmentCbeCase',      label: 'CBE case in treatment',   short: 'CBE · tx',     phone: 'CBE in treatment',   badge: 'badge-purple',   modality: 'Breast (CBE)', treatment: true },
  { key: 'openPapSmearCase',      label: 'Open PAP smear case',     short: 'PAP · open',   phone: 'PAP open',           badge: 'badge-moderate', modality: 'PAP smear' },
  { key: 'treatmentPapSmearCase', label: 'PAP smear case in treatment', short: 'PAP · tx', phone: 'PAP in treatment',   badge: 'badge-purple',   modality: 'PAP smear',    treatment: true },
  { key: 'cervicalInfectionCase', label: 'Cervical infection case', short: 'Cervical inf.', phone: 'Cervical infection', badge: 'badge-moderate', modality: 'PAP smear' },
];

export function formatDate(value) {
  if (!value) return null;
  return new Date(value).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

// Age recorded at the camp wins over one computed from DOB — a re-screen years
// later must not rewrite what was true at the time.
export function ageLabel(record) {
  if (record.ageAtScreening != null) return `${record.ageAtScreening} yrs`;
  return formatDate(record.dateOfBirth);
}
